import { Input } from '@kognitos/lattice';
import type { DateInputProps } from '../types';

/**
 * Date input component for date selection
 *
 * Renders a native date picker input that handles dates in YYYY-MM-DD format.
 * Converts between browser date format and TypeDate structure.
 *
 * @param props - Component props
 * @returns JSX element containing the date input field
 */
export function DateInput({
  name,
  value,
  onChange,
  error,
  required,
  placeholder,
  disabled,
}: DateInputProps) {
  return (
    <Input
      id={name}
      name={name}
      type="date"
      max="9999-12-31"
      value={value}
      onChange={e => onChange(e.target.value)}
      placeholder={placeholder}
      required={required}
      aria-invalid={!!error}
      className={
        error ? 'border-destructive focus-visible:ring-destructive' : ''
      }
      disabled={disabled}
      data-testid={`input-${name}`}
    />
  );
}
